



















































import Onboarding from '@/util/Onboarding'
import { Vue, Component } from 'vue-property-decorator'

interface InputValue {
    value: string
    error: string | null
}

@Component({ name: 'master-password' })
export default class MasterPassword extends Vue {
    public password: InputValue = { value: '', error: null }
    public confirmPassword: InputValue = { value: '', error: null }

    public mounted(): void {
        (this.$refs.masterPassword as HTMLElement).focus()
    }

    public finish(): void {
        if (this.password.value === '' || this.password.value === null) {
            this.password.error = 'Password is empty'
            return
        }
        if (this.confirmPassword.value === '' || this.confirmPassword.value === null) {
            this.confirmPassword.error = 'Password confirmation is empty'
            return
        }
        if (this.password.value !== this.confirmPassword.value) {
            this.confirmPassword.error = 'Passwords do not match'
            return
        }
        Onboarding.generateKeys(this.password.value)
        this.$emit('master-password-complete')
    }
}
